"use strict";

var _slicedToArray = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var SequenceLogoGlyphs_1 = require("./SequenceLogoGlyphs");
var Utils_1 = require("./Utils");
var MolecularStyles_1 = require("./MolecularStyles");
var AminoAcid = /*#__PURE__*/function () {
  function AminoAcid(singleLetterCode, threeLetterCode, fullName) {
    _classCallCheck(this, AminoAcid);
    this.singleLetterCode = singleLetterCode;
    this.threeLetterCode = threeLetterCode;
    this.fullName = fullName;
    this.singleLetterCode = singleLetterCode;
    this.threeLetterCode = threeLetterCode;
    this.fullName = fullName;
    this.glyph = SequenceLogoGlyphs_1.GlyphFactory.glyphFromChar(singleLetterCode);
    this.colors = MolecularStyles_1.ALL_AMINOACID_COLORSCHEMES.reduce(function (acc, cs) {
      var colorPair = Object.entries(cs.colors).find(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          aa = _ref2[0],
          color = _ref2[1];
        if (aa === singleLetterCode) {
          return true;
        }
        return false;
      });
      var colorString = "#ffffff";
      if (colorPair) {
        colorString = colorPair[1];
      }
      var colorInfo = Utils_1.stringToColor(colorString);
      acc[cs.commonName] = {
        hexString: colorInfo.hex,
        rgb: colorInfo.rgb,
        backgroundAlpha: cs.backgroundAlpha
      };
      return acc;
    }, {});
  }
  _createClass(AminoAcid, null, [{
    key: "fromSingleLetterCode",
    value: function fromSingleLetterCode(singleLetterCode) {
      if (singleLetterCode in this.bySingleLetterCode) {
        return AminoAcid.bySingleLetterCode[singleLetterCode];
      }
      return AminoAcid.UNKNOWN;
    }
  }, {
    key: "fromThreeLetterCode",
    value: function fromThreeLetterCode(threeLetterCode) {
      if (threeLetterCode in this.byThreeLetterCode) {
        return AminoAcid.byThreeLetterCode[threeLetterCode];
      }
      return AminoAcid.UNKNOWN;
    }
  }]);
  return AminoAcid;
}();
exports.AminoAcid = AminoAcid;
AminoAcid.canonicalAminoAcids = [new AminoAcid("A", "ALA", "Alanine"), new AminoAcid("R", "ARG", "Arginine"), new AminoAcid("N", "ASN", "Asparagine"), new AminoAcid("D", "ASP", "Aspartic Acid"), new AminoAcid("C", "CYS", "Cysteine"), new AminoAcid("Q", "GLU", "Glutamine"), new AminoAcid("E", "GLN", "Glutamic Acid"), new AminoAcid("G", "GLY", "Glycine"), new AminoAcid("H", "HIS", "Histidine"), new AminoAcid("I", "ILE", "Isoleucine"), new AminoAcid("L", "LEU", "Leucine"), new AminoAcid("K", "LYS", "Lysine"), new AminoAcid("M", "MET", "Methionine"), new AminoAcid("F", "PHE", "Phenylalanine"), new AminoAcid("P", "PRO", "Proline"), new AminoAcid("S", "SER", "Serine"), new AminoAcid("T", "THR", "Threonine"), new AminoAcid("W", "TRP", "Tryptophan"), new AminoAcid("Y", "TYR", "Tyrosine"), new AminoAcid("V", "VAL", "Valine"), new AminoAcid("X", "UKN", "Unknown")];
AminoAcid.bySingleLetterCode = AminoAcid.canonicalAminoAcids.reduce(function (acc, aa) {
  acc[aa.singleLetterCode] = aa;
  return acc;
}, {});
AminoAcid.byThreeLetterCode = AminoAcid.canonicalAminoAcids.reduce(function (acc, aa) {
  acc[aa.threeLetterCode] = aa;
  return acc;
}, {});
AminoAcid.UNKNOWN = AminoAcid.bySingleLetterCode["X"];
var Nucleotide = /*#__PURE__*/function () {
  function Nucleotide(singleLetterCode, fullName) {
    _classCallCheck(this, Nucleotide);
    this.singleLetterCode = singleLetterCode;
    this.fullName = fullName;
    this.singleLetterCode = singleLetterCode;
    this.fullName = fullName;
    this.glyph = SequenceLogoGlyphs_1.GlyphFactory.glyphFromChar(singleLetterCode);
    this.colors = MolecularStyles_1.ALL_NUCLEOTIDE_COLORSCHEMES.reduce(function (acc, cs) {
      var colorPair = Object.entries(cs.colors).find(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          aa = _ref4[0],
          color = _ref4[1];
        if (aa === singleLetterCode) {
          return true;
        }
        return false;
      });
      var colorString = "#ffffff";
      if (colorPair) {
        colorString = colorPair[1];
      }
      var colorInfo = Utils_1.stringToColor(colorString);
      acc[cs.commonName] = {
        hexString: colorInfo.hex,
        rgb: colorInfo.rgb,
        backgroundAlpha: cs.backgroundAlpha
      };
      return acc;
    }, {});
  }
  _createClass(Nucleotide, null, [{
    key: "fromSingleLetterCode",
    value: function fromSingleLetterCode(singleLetterCode) {
      singleLetterCode = singleLetterCode.toUpperCase();
      if (this.bySingleLetterCode[singleLetterCode]) {
        return Nucleotide.bySingleLetterCode[singleLetterCode];
      }
      return Nucleotide.UNKNOWN;
    }
  }]);
  return Nucleotide;
}();
exports.Nucleotide = Nucleotide;
Nucleotide.allNucleotides = [new Nucleotide("A", "Adenine"), new Nucleotide("C", "Cytosine"), new Nucleotide("G", "Guanine"), new Nucleotide("T", "Thymidine"), new Nucleotide("U", "Uracil"), new Nucleotide("R", "Purine"), new Nucleotide("Y", "Pyrimidine"), new Nucleotide("X", "Unknown")];
Nucleotide.bySingleLetterCode = Nucleotide.allNucleotides.reduce(function (acc, aa) {
  acc[aa.singleLetterCode] = aa;
  return acc;
}, {});
Nucleotide.UNKNOWN = Nucleotide.bySingleLetterCode["X"];